import request from "../../utils/fetch";
export const getAllSubscriptionOrders = () => request.get("subscription/orders");
